import { PlusOutlined } from "@ant-design/icons";
import { Button, Checkbox, Col, Row, Space, Tag, Typography } from "antd";
import NotSet from "../../../components/NotSet";
import { TransferListingItem } from "../Create";
import { CustomPhotosItem } from "../../../types/file.type";
import { mappingColorListingStatus } from "../../../helpers/listing";
import { useMemo } from "react";

interface ListingGridItemCardProps {
	value?: TransferListingItem;
	onChange?: (value?: TransferListingItem) => void;
	onPickSingle?: (item: TransferListingItem) => void;
	disablePickSingle?: boolean;
	hideCheckbox?: boolean;
	onShowDetail?: (value?: TransferListingItem) => void;
}
const { Paragraph, Text } = Typography;
const ListingGridItemCard: React.FC<ListingGridItemCardProps> = ({
	value,
	onChange,
	onPickSingle,
	disablePickSingle,
	hideCheckbox,
	onShowDetail,
}) => {
	let image = value?.photos?.[0] ? (value?.photos[0] as CustomPhotosItem).url : "/images/no-preview.jpg";

	const _handleCheckBox = (isChecked: boolean) => {
		if (value) {
			onChange?.({
				...value,
				checked: isChecked,
			});
		}
	};

	const currentListingStatus = useMemo(() => {
		const status = value?.status;

		return mappingColorListingStatus(status!);
	}, [value?.status]);

	return (
		<Row
			gutter={[10, 0]}
			wrap={false}
		>
			<Col
				flex="100px"
				className="checkbox-listing-container"
			>
				<img
					className="card-user-photo"
					style={{ borderRadius: 0 }}
					src={image}
					alt={value?.title}
				/>
				{!hideCheckbox && (
					<Checkbox
						checked={value?.checked}
						onChange={(e) => _handleCheckBox(e.target.checked)}
					/>
				)}
			</Col>
			<Col flex="auto">
				<Space
					size={2}
					wrap
				>
					<Button
						type="link"
						style={{ padding: 0, height: "auto" }}
						onClick={() => onShowDetail?.(value)}
					>
						{value?.listingCode ?? <NotSet />}
					</Button>
					<Tag
						color={currentListingStatus.color as any}
						style={{ fontSize: 10, padding: "0px 4px" }}
					>
						{currentListingStatus.label}
					</Tag>
				</Space>

				<Paragraph
					type="secondary"
					style={{ margin: 0 }}
					ellipsis={{
						rows: 2,
					}}
				>
					{value?.title}
				</Paragraph>
				<Row
					gutter={[24, 0]}
					align="middle"
					wrap={false}
				>
					<Col flex="auto">
						<Text ellipsis={true}>{value?.agent.name}</Text>
					</Col>
					{!disablePickSingle && (
						<Col flex="50px">
							<Button
								type="text"
								danger={true}
								icon={<PlusOutlined />}
								size="small"
								onClick={() => value && onPickSingle?.(value)}
							/>
						</Col>
					)}
				</Row>
			</Col>
		</Row>
	);
};
export default ListingGridItemCard;
